import { NgModule } from '@angular/core';

import { HisGenericsearchSharedModule } from './his-genericsearch-shared.module';
import { HisGenericsearchRoutesModule } from './his-genericsearch.routes';

/**
 * The core module for the generic search.
 */
@NgModule( {
    imports: [
        HisGenericsearchSharedModule,
        HisGenericsearchRoutesModule
    ],
    declarations: [
    ],
    exports: [
        HisGenericsearchSharedModule
    ]
} )

export class HisGenericsearchCoreModule {

}
